import Vue from "vue";
import Vuex from "vuex";
import FeatureUsageStore from "./modules/featureUsage/stores";
import TenantAnalyticsStore from "./modules/Tenant/analytics/stores";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    featureUsage: FeatureUsageStore,
    TenantAnalyticsStore: TenantAnalyticsStore
  }
});
